import benefitsDataDe from '../data/BenefitsData/benefitsDataDe';
import { LangData } from '../types/langTypes';

const de: LangData = {
  id: "de",
  name: "Deutsch",
  images: [],
  altText: "",
  description: "Deutsche Übersetzung für die Webseite.",
  portfolioDescription1: "Responsive One-Page-Website für eine Eiskrem-Marke: mit Produkt-Präsentation, „Wie es gemacht wird“-Sektion, Galerie und Kontaktformular. Umgesetzt mit HTML, CSS (mobile-first) und JavaScript.",
  portfolioDescription2: "Eine moderne responsive E-Commerc-Webanwendung mit klarem UI/UX-Design: Echtzeit-Produktfilter, Warenkorb-Management und mobile-first Layout. Eingesetzte Technologien: React, TypeScript, Redux und SCSS.",
  portfolioDescription3: "",
  portfolioDescription4: "",
  portfolioDescription5: "",
  portfolioDescription6: "",
  portfolioDescription: 'Portfolio-Beschreibung',
  backToTop: 'Nach oben',
  mainNavigationLabel: "Hauptnavigation",
  mainNavigation: ['Startseite', 'Über uns', 'Dienstleistungen', 'Portfolio', 'Kontakt'],

  logoTaglines: {
    top: "Denke mutig",
    bottom: "Kreiere klug",
  },
  home: "Startseite",
  about: "Über uns",
  aboutmain: "Über uns",
  aboutTitle: "ÜBER UNS",
  aboutSubtitle: "Architekten digitaler Überlegenheit",
  aboutText: "SYDRIX ist der Punkt, an dem hohe Ingenieursästhetik auf kompromisslose Business-Effizienz trifft. Gegründet von einem ukrainischen Tech-Visionär im Herzen Bayerns, steht unser Studio für digitale Resilienz und Innovation. Wir entwickeln nicht nur Interfaces – wir erschaffen digitale Assets, die dem Markt voraus sind. Unser Ansatz basiert auf drei Säulen: Performance-First (Geschwindigkeit als Religion), Inclusive Design (Barrierefreiheit als Standard) und Scalable Architecture (Bereitschaft für das zehnfache Wachstum Ihres Unternehmens). Wir glauben, dass perfekter Code unsichtbar sein sollte, das Ergebnis jedoch in jedem Gewinnbericht spürbar sein muss. Mit SYDRIX erhalten Sie nicht nur ein Frontend, sondern einen technologischen Vorsprung, der Ihre Marke zum Marktführer des digitalen Zeitalters macht.",
  aboutPhilosophyTitle: "Unsere Philosophie",
  aboutPhilosophyText: "Wir ersetzen veraltete Methoden durch einen frischen Blick auf Performance. Unser Ansatz garantiert eine Architektur, die auch in Zukunft Bestand hat.",
  aboutButton: "Mehr erfahren",
  aboutButtonText: "Ansehen",
  aboutButtonLink: "/about",
  aboutImageAlt: "Über uns Bild",
  aboutList: ["Professionelles Team", "Moderne Technologien", "Individueller Ansatz"],
  aboutQuote: "Wir lieben, was wir tun!",
  aboutQuoteAuthor: "Teamgründer",
  aboutStats: [
    { label: "Tech-Stack", value: "Next.js" },
    { label: "Qualitätsfokus", value: "100%" }
  ],
  aboutMission: "Wir verwandeln komplexe Technologien in Ihre strategischen Assets und sichern Ihrem Business die Marktführung im digitalen Zeitalter.",
  aboutVision: "Der globale Maßstab für Frontend-Engineering zu werden, bei dem jedes Pixel zum Gewinn des Kunden beiträgt.",
  aboutValues: ["Technische Exzellenz", "Radikale Transparenz", "Skalierbare Innovationen"],
  aboutTeam: "Unser Team ist unser wertvollstes Kapital.",
  aboutPartners: "Unsere Partner vertrauen uns.",
  aboutClients: "Unsere Kunden sind unsere Freunde.",
  aboutHistory: "Die Geschichte des Unternehmens begann im Jahr 2025.",
  services: "Dienstleistungen",
  servicesTitle: "Unsere Dienstleistungen",
  servicesContactText: "Kontaktieren Sie uns für weitere Details",
  servicesButton: "Mehr erfahren",
  servicesFormTitle: "Kostenlose Beratung erhalten",
  servicesFormPlaceholder: "Ihre E-Mail-Adresse",
  servicesFormButton: "Senden",
  showLessButton: "Weniger anzeigen",
  showMoreButton: "Mehr anzeigen",

  portfolio: "Portfolio",
  portfolioTitle: "Portfolio",
  portfolioText: "Umgesetzte Ideen",
  portfolioLabel: "Portfolio",
  viewOnGithub: "Auf GitHub ansehen",
  noProjectsFound: "Keine Projekte gefunden.",

  testimonials: "Kundenstimmen",
  testimonialsText: "Wir danken all unseren Kunden für ihr Feedback!",
  blogTitle: "Blog",
  contacts: "Kontakt",
  contactsTitle: "Kontakt",
  phone: "Telefon",
  email: "E-Mail",
  faq: "FAQ",
  partnership: "Partnerschaft",
  showAllButton: "Alle anzeigen",
  hideAllButton: "Ausblenden",
  title: "Frontend-Entwicklung für Ihr Unternehmen",
  subtitle: [
    "Beeindruckende Geschwindigkeit.",
    "Unvergessliches Design.",
    "Fesselnde Erfahrung."
  ],
  button: "Lassen Sie uns sprechen",
  benefitsTitle: "Vorteile der Zusammenarbeit",
  benefitsSubtitle: "Warum Kunden uns wählen",
  benefitsText: "Wir erstellen Websites, die schnell, sicher und effizient funktionieren.",
  benefits: benefitsDataDe,
  goTo: "gehen zu",
  footer: "Entwickelt von Artem Sydorov",
  heroTitle: "Frontend-Entwicklung für Ihr Unternehmen",
  heroSubtitle: [
    "Beeindruckende Geschwindigkeit.",
    "Unvergessliches Design.",
    "Fesselnde Erfahrung."
  ],
  heroButton: "Lassen Sie uns sprechen",
  portfolioLink: "/portfolio",
  portfolioLinkText: "Portfolio ansehen",

  serviceDetailsTitle: "Dienstleistungsdetails",
  serviceDetailsText: "Detaillierte Informationen über unsere Dienstleistungen.",
  servicesDetailsButton: "Mehr über die Dienstleistung erfahren",
  servicesDetailsSubtitle: "Mehr über unsere Dienstleistungen",
  servicesDetailsList: ["Dienstleistung 1", "Dienstleistung 2", "Dienstleistung 3"],
  notFoundTitle: "Seite nicht gefunden",
  notFoundText: "Entschuldigung, diese Seite existiert nicht.",
  notFoundButton: "Zur Startseite",
  cookieConsentText: "Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern.",
  cookieConsentButton: "Verstanden",
  privacyPolicy: "Datenschutzrichtlinie",
  termsOfService: "Nutzungsbedingungen",
  loading: "Laden...",
  error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  success: "Erfolgreich!",
  language: "Sprache",
  selectLanguage: "Sprache auswählen",
  close: "Schließen",

  serviceDetailsBack: "Zurück zu den Dienstleistungen",
  faqTitle: "Häufig gestellte Fragen",
  faqSubtitle: "Antworten auf häufige Fragen",
  faqText: "Wenn Sie Fragen haben, sehen Sie sich diesen Abschnitt an oder kontaktieren Sie uns.",
  team: "Team",
  teamTitle: "Unser Team",
  teamText: "Wir sind ein Team von Fachleuten, die ihre Arbeit lieben.",
  process: "Prozess",
  processTitle: "Wie wir arbeiten",
  processText: "Wir folgen einem transparenten Entwicklungsprozess.",
  technologies: "Technologien",
  technologiesTitle: "Technologien, die wir verwenden",
  technologiesText: "Wir nutzen moderne Frameworks und Tools.",
  price: "Preis",
  priceTitle: "Dienstleistungspreise",
  priceText: "Erfahren Sie mehr über unsere Preise.",

  processSubtitle: "Unsere Arbeitsphasen",
  teamSubtitle: "Lernen Sie unser Team kennen",
  teamButton: "Mehr über das Team erfahren",
  teamButtonText: "Team ansehen",
  processButton: "Mehr über den Prozess erfahren",
  processButtonText: "Prozess ansehen",
  technologiesSubtitle: "Unsere Technologien",
  technologiesButton: "Mehr über Technologien erfahren",
  technologiesButtonText: "Technologien ansehen",
  priceSubtitle: "Preisinformationen",
  priceButton: "Mehr über Preise erfahren",
  priceButtonText: "Preise ansehen",

  teamButtonLink: "/team",
  portfolioButton: "Mehr über das Portfolio erfahren",
  portfolioButtonText: "Portfolio ansehen",
  portfolioButtonLink: "/portfolio",
  blogButton: "Mehr über den Blog erfahren",
  blogButtonText: "Blog ansehen",
  blogButtonLink: "/blog",
  contactsButton: "Mehr über den Kontakt erfahren",
  contactsButtonText: "Kontakt ansehen",
  contactsButtonLink: "/contacts",
  faqButton: "Mehr über FAQ erfahren",
  faqButtonText: "FAQ ansehen",
  faqButtonLink: "/faq",
  notFoundButtonText: "Zurück zur Startseite",
  cookieConsentMore: "Mehr erfahren",
  privacyPolicyButton: "Datenschutzrichtlinie ansehen",
  termsOfServiceButton: "Nutzungsbedingungen ansehen",

  contactsButtonLinkText: "Zum Kontakt",
  cookieConsentLink: "/privacy-policy",
  privacyPolicyButtonText: "Datenschutzrichtlinie ansehen",
  termsOfServiceButtonText: "Nutzungsbedingungen ansehen",
  aboutButtonLinkText: "Mehr über uns",
  servicesButtonLinkText: "Mehr über Dienstleistungen",
  portfolioButtonLinkText: "Mehr über das Portfolio",
  blogButtonLinkText: "Mehr über den Blog",
  faqButtonLinkText: "Mehr über FAQ",
  teamButtonLinkText: "Mehr über das Team",
  processButtonLinkText: "Mehr über den Prozess",
  technologiesButtonLinkText: "Mehr über Technologien",
  priceButtonLinkText: "Mehr über Preise",
  notFoundButtonLinkText: "Zurück zur Startseite",
  cookieConsentButtonText: "Verstanden",
  cookieConsentMoreText: "Mehr erfahren",

  faqQuestion: "Frage",
  faqAnswer: "Antwort",
  priceButtonLink: "/price",
  processButtonLink: "/process",
  technologiesButtonLink: "/technologies",
  servicesButtonLink: "/services",
  notFoundButtonLink: "/",
  privacyPolicyLink: "/privacy-policy",
  termsOfServiceLink: "/terms-of-service",

  partnershipTitle: "Partnerschaft",
  partnershipSubtitle: "Kooperationsmöglichkeiten",
  partnershipText: "Wir sind offen für Partnerschaften und neue Kooperationsmöglichkeiten.",
  notFoundBackButton: "Zurück",
  extraField1: "Zusätzliches Feld 1",
  extraField2: "Zusätzliches Feld 2",

  notFoundLink: "/",
  cookieConsent: "Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern.",
  toggleMenu: "Menü umschalten",
  noPortfolioItems: 'Portfolio ist momentan leer',
  noImages: 'Keine Bilder verfügbar',
  "impressum.back": "Zurück",
  "impressum.subtitle": "Rechtliche Hinweise",
  "impressum.infoTitle": "Angaben gemäß § 5 TMG",
  "impressum.owner": "Inhaber",
  "impressum.address": "Hochriesstraße 29",
  "impressum.city": "83209 Prien am Chiemsee, Deutschland",
  "impressum.contactTitle": "Kontakt",
  "impressum.email": "E-Mail",
  "impressum.website": "Webseite",
  "impressum.copyrightTitle": "Urheberrecht",
  "impressum.rights": "Alle Rechte vorbehalten.",
  "impressum.disputeTitle": "Streitbeilegung",
  "impressum.disputeText": "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
  "impressum.disclaimerTitle": "Haftungsausschluss",
  "impressum.disclaimerText": "Haftung für Inhalte: Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Haftung für Links: Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.",
  "impressum.phone": "Telefon",
  "impressum.taxStatus": "Gemäß § 19 UStG wird keine Umsatzsteuer erhoben (Kleinunternehmerstatus).",
  "impressum.responsible": "Verantwortlich für den Inhalt nach § 18 MStV",
  "impressum.disputeFinal": "Ich bin nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
  "impressum.copyrightText": "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
  "impressum.copyrightLinkText": "Gesetz über Urheberrecht und verwandte Schutzrechte (UrhG)",

  "privacy.title": "Datenschutzerklärung",
  "privacy.intro": "Ich nehme den Schutz Ihrer persönlichen Daten sehr ernst. Diese Webseite ist so konzipiert, dass so wenig Daten wie möglich verarbeitet werden.",
  "privacy.hostingTitle": "1. Externes Hosting",
  "privacy.hostingText": "Diese Webseite wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Dies umfasst primär IP-Adressen und Metadaten. Der Einsatz des Hosters erfolgt im Interesse einer sicheren und schnellen Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).",
  "privacy.dataTitle": "2. Datensparsamkeit",
  "privacy.dataText": "Im Sinne der Datensparsamkeit verzichtet diese Seite auf den Einsatz von Cookies, Analyse-Tools (Tracking) und Kontaktformularen. Es findet keine Auswertung Ihres Nutzerverhaltens statt.",
  "privacy.rightsTitle": "3. Betroffenenrechte",
  "privacy.rightsText": "Im Rahmen der geltenden gesetzlichen Bestimmungen haben Sie jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten sowie ein Recht auf Berichtigung oder Löschung dieser Daten.",
  "privacy.contactTitle": "4. Verantwortliche Stelle",
  "privacy.contactText": "Der Verantwortliche für die Datenverarbeitung ist Artem Sydorov. Die vollständigen Kontaktdaten finden Sie im Impressum dieser Seite.",
};

export default de;
